import * as yup from 'yup';

const weitereAusstattung = yup.boolean().default(false);

export const weitereAusstattungSchema = yup.object({
  naturschieferdach: weitereAusstattung,
  kupferdach: weitereAusstattung,
  naturstein: weitereAusstattung,
  klinker: weitereAusstattung,
  stuck: weitereAusstattung,
  edelholz: weitereAusstattung,
  marmorboden: weitereAusstattung,
  parkett: weitereAusstattung,
  leichtmetallfenster: weitereAusstattung,
  edelholztueren: weitereAusstattung,
  sanitaer: weitereAusstattung,
  whirlpool: weitereAusstattung,
  bidet: weitereAusstattung,
  badewanneDusche: weitereAusstattung,
  baeder: weitereAusstattung,
  elektronik: weitereAusstattung,
  einbaukuechen: weitereAusstattung,
  wintergarten: weitereAusstattung,
  exotischeHoelzer: weitereAusstattung,
  kuenstlerischesGlas: weitereAusstattung,
  kuenstlerischeWaende: weitereAusstattung,
  glasfassaden: weitereAusstattung,
  fachwerk: weitereAusstattung,
});

export type WeitereAusstattungSchema = yup.Asserts<
  typeof weitereAusstattungSchema
>;
